import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

addToChainAfter(chain, PopulateApiParameter, props => {
    const state = props.getState() as CustomApplicationState;
    const CustomState = state.KGPState.CheckoutReview;
    const {
        SpecialDeliveryInstructionList,
        accountNumber,
        approvalNotes,
        workOrder,
        releaseNumber,
        packingListNotesList,
    } = CustomState;
    props.apiParameter.cart.notes = approvalNotes || "";
    props.apiParameter.cart.properties = {
        shippingCollectAccountNumber: accountNumber || "",
        userSelectedSpecialDeliveryInstruction: (SpecialDeliveryInstructionList as string) || "",
        workOrderNumber: workOrder || "",
        releaseNumber: releaseNumber || "",
        packingListAndInstructions: packingListNotesList || "",
    };
});
